/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Samlla
 * Samlla Backend API
 * OpenAPI spec version: 0.1.0
 */
import { createMutation, createQuery } from '@tanstack/svelte-query';
import type {
	CreateMutationOptions,
	CreateMutationResult,
	CreateQueryOptions,
	CreateQueryResult,
	DataTag,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey
} from '@tanstack/svelte-query';

import type {
	CategoryCreate,
	CategoryFavoriteResponse,
	CategoryList,
	CategoryNestRequest,
	CategoryParentUpdateRequest,
	CategoryRead,
	CategoryReorderRequest,
	CategoryTree,
	CategoryUpdate,
	CategoryWithPath,
	HTTPValidationError
} from '.././schemas';

import { customInstance } from '../../orval/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Get all categories for the current user.
 * @summary Get Categories
 */
export const getCategoriesApiCategoriesGet = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<CategoryList>({ url: `/api/categories`, method: 'GET', signal }, options);
};

export const getGetCategoriesApiCategoriesGetQueryKey = () => {
	return [`/api/categories`] as const;
};

export const getGetCategoriesApiCategoriesGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getCategoriesApiCategoriesGet>>,
	TError = unknown
>(options?: {
	query?: Partial<
		CreateQueryOptions<Awaited<ReturnType<typeof getCategoriesApiCategoriesGet>>, TError, TData>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetCategoriesApiCategoriesGetQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoriesApiCategoriesGet>>> = ({
		signal
	}) => getCategoriesApiCategoriesGet(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getCategoriesApiCategoriesGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoriesApiCategoriesGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getCategoriesApiCategoriesGet>>
>;
export type GetCategoriesApiCategoriesGetQueryError = unknown;

/**
 * @summary Get Categories
 */

export function createGetCategoriesApiCategoriesGet<
	TData = Awaited<ReturnType<typeof getCategoriesApiCategoriesGet>>,
	TError = unknown
>(
	options?: {
		query?: Partial<
			CreateQueryOptions<Awaited<ReturnType<typeof getCategoriesApiCategoriesGet>>, TError, TData>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetCategoriesApiCategoriesGetQueryOptions(options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Create a new category.
 * @summary Create Category
 */
export const createCategoryApiCategoriesPost = (
	categoryCreate: CategoryCreate,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<CategoryRead>(
		{
			url: `/api/categories`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: categoryCreate,
			signal
		},
		options
	);
};

export const getCreateCategoryApiCategoriesPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof createCategoryApiCategoriesPost>>,
		TError,
		{ data: CategoryCreate },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof createCategoryApiCategoriesPost>>,
	TError,
	{ data: CategoryCreate },
	TContext
> => {
	const mutationKey = ['createCategoryApiCategoriesPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof createCategoryApiCategoriesPost>>,
		{ data: CategoryCreate }
	> = (props) => {
		const { data } = props ?? {};

		return createCategoryApiCategoriesPost(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type CreateCategoryApiCategoriesPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof createCategoryApiCategoriesPost>>
>;
export type CreateCategoryApiCategoriesPostMutationBody = CategoryCreate;
export type CreateCategoryApiCategoriesPostMutationError = HTTPValidationError;

/**
 * @summary Create Category
 */
export const createCreateCategoryApiCategoriesPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof createCategoryApiCategoriesPost>>,
			TError,
			{ data: CategoryCreate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof createCategoryApiCategoriesPost>>,
	TError,
	{ data: CategoryCreate },
	TContext
> => {
	const mutationOptions = getCreateCategoryApiCategoriesPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Reorder categories according to provided list of category IDs.
 * @summary Reorder Categories
 */
export const reorderCategoriesApiCategoriesReorderPut = (
	categoryReorderRequest: CategoryReorderRequest,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<CategoryRead[]>(
		{
			url: `/api/categories/reorder`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: categoryReorderRequest
		},
		options
	);
};

export const getReorderCategoriesApiCategoriesReorderPutMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof reorderCategoriesApiCategoriesReorderPut>>,
		TError,
		{ data: CategoryReorderRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof reorderCategoriesApiCategoriesReorderPut>>,
	TError,
	{ data: CategoryReorderRequest },
	TContext
> => {
	const mutationKey = ['reorderCategoriesApiCategoriesReorderPut'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof reorderCategoriesApiCategoriesReorderPut>>,
		{ data: CategoryReorderRequest }
	> = (props) => {
		const { data } = props ?? {};

		return reorderCategoriesApiCategoriesReorderPut(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ReorderCategoriesApiCategoriesReorderPutMutationResult = NonNullable<
	Awaited<ReturnType<typeof reorderCategoriesApiCategoriesReorderPut>>
>;
export type ReorderCategoriesApiCategoriesReorderPutMutationBody = CategoryReorderRequest;
export type ReorderCategoriesApiCategoriesReorderPutMutationError = HTTPValidationError;

/**
 * @summary Reorder Categories
 */
export const createReorderCategoriesApiCategoriesReorderPut = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof reorderCategoriesApiCategoriesReorderPut>>,
			TError,
			{ data: CategoryReorderRequest },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof reorderCategoriesApiCategoriesReorderPut>>,
	TError,
	{ data: CategoryReorderRequest },
	TContext
> => {
	const mutationOptions = getReorderCategoriesApiCategoriesReorderPutMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Nest a category under a parent (create parent-child relationship).
 * @summary Nest Category
 */
export const nestCategoryApiCategoriesCategoryIdNestPost = (
	categoryId: string,
	categoryNestRequest: CategoryNestRequest,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<CategoryRead>(
		{
			url: `/api/categories/${categoryId}/nest`,
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			data: categoryNestRequest,
			signal
		},
		options
	);
};

export const getNestCategoryApiCategoriesCategoryIdNestPostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof nestCategoryApiCategoriesCategoryIdNestPost>>,
		TError,
		{ categoryId: string; data: CategoryNestRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof nestCategoryApiCategoriesCategoryIdNestPost>>,
	TError,
	{ categoryId: string; data: CategoryNestRequest },
	TContext
> => {
	const mutationKey = ['nestCategoryApiCategoriesCategoryIdNestPost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof nestCategoryApiCategoriesCategoryIdNestPost>>,
		{ categoryId: string; data: CategoryNestRequest }
	> = (props) => {
		const { categoryId, data } = props ?? {};

		return nestCategoryApiCategoriesCategoryIdNestPost(categoryId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type NestCategoryApiCategoriesCategoryIdNestPostMutationResult = NonNullable<
	Awaited<ReturnType<typeof nestCategoryApiCategoriesCategoryIdNestPost>>
>;
export type NestCategoryApiCategoriesCategoryIdNestPostMutationBody = CategoryNestRequest;
export type NestCategoryApiCategoriesCategoryIdNestPostMutationError = HTTPValidationError;

/**
 * @summary Nest Category
 */
export const createNestCategoryApiCategoriesCategoryIdNestPost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof nestCategoryApiCategoriesCategoryIdNestPost>>,
			TError,
			{ categoryId: string; data: CategoryNestRequest },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof nestCategoryApiCategoriesCategoryIdNestPost>>,
	TError,
	{ categoryId: string; data: CategoryNestRequest },
	TContext
> => {
	const mutationOptions = getNestCategoryApiCategoriesCategoryIdNestPostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Update a category's parent (move in hierarchy or make top-level).
 * @summary Update Category Parent
 */
export const updateCategoryParentApiCategoriesCategoryIdParentPut = (
	categoryId: string,
	categoryParentUpdateRequest: CategoryParentUpdateRequest,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<CategoryRead>(
		{
			url: `/api/categories/${categoryId}/parent`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: categoryParentUpdateRequest
		},
		options
	);
};

export const getUpdateCategoryParentApiCategoriesCategoryIdParentPutMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof updateCategoryParentApiCategoriesCategoryIdParentPut>>,
		TError,
		{ categoryId: string; data: CategoryParentUpdateRequest },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof updateCategoryParentApiCategoriesCategoryIdParentPut>>,
	TError,
	{ categoryId: string; data: CategoryParentUpdateRequest },
	TContext
> => {
	const mutationKey = ['updateCategoryParentApiCategoriesCategoryIdParentPut'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateCategoryParentApiCategoriesCategoryIdParentPut>>,
		{ categoryId: string; data: CategoryParentUpdateRequest }
	> = (props) => {
		const { categoryId, data } = props ?? {};

		return updateCategoryParentApiCategoriesCategoryIdParentPut(categoryId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateCategoryParentApiCategoriesCategoryIdParentPutMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateCategoryParentApiCategoriesCategoryIdParentPut>>
>;
export type UpdateCategoryParentApiCategoriesCategoryIdParentPutMutationBody =
	CategoryParentUpdateRequest;
export type UpdateCategoryParentApiCategoriesCategoryIdParentPutMutationError = HTTPValidationError;

/**
 * @summary Update Category Parent
 */
export const createUpdateCategoryParentApiCategoriesCategoryIdParentPut = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof updateCategoryParentApiCategoriesCategoryIdParentPut>>,
			TError,
			{ categoryId: string; data: CategoryParentUpdateRequest },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof updateCategoryParentApiCategoriesCategoryIdParentPut>>,
	TError,
	{ categoryId: string; data: CategoryParentUpdateRequest },
	TContext
> => {
	const mutationOptions =
		getUpdateCategoryParentApiCategoriesCategoryIdParentPutMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Get category tree with custom ordering applied.
 * @summary Get Category Tree Ordered
 */
export const getCategoryTreeOrderedApiCategoriesTreeOrderedGet = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<CategoryTree[]>(
		{ url: `/api/categories/tree/ordered`, method: 'GET', signal },
		options
	);
};

export const getGetCategoryTreeOrderedApiCategoriesTreeOrderedGetQueryKey = () => {
	return [`/api/categories/tree/ordered`] as const;
};

export const getGetCategoryTreeOrderedApiCategoriesTreeOrderedGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getCategoryTreeOrderedApiCategoriesTreeOrderedGet>>,
	TError = unknown
>(options?: {
	query?: Partial<
		CreateQueryOptions<
			Awaited<ReturnType<typeof getCategoryTreeOrderedApiCategoriesTreeOrderedGet>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetCategoryTreeOrderedApiCategoriesTreeOrderedGetQueryKey();

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getCategoryTreeOrderedApiCategoriesTreeOrderedGet>>
	> = ({ signal }) => getCategoryTreeOrderedApiCategoriesTreeOrderedGet(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getCategoryTreeOrderedApiCategoriesTreeOrderedGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryTreeOrderedApiCategoriesTreeOrderedGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getCategoryTreeOrderedApiCategoriesTreeOrderedGet>>
>;
export type GetCategoryTreeOrderedApiCategoriesTreeOrderedGetQueryError = unknown;

/**
 * @summary Get Category Tree Ordered
 */

export function createGetCategoryTreeOrderedApiCategoriesTreeOrderedGet<
	TData = Awaited<ReturnType<typeof getCategoryTreeOrderedApiCategoriesTreeOrderedGet>>,
	TError = unknown
>(
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getCategoryTreeOrderedApiCategoriesTreeOrderedGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetCategoryTreeOrderedApiCategoriesTreeOrderedGetQueryOptions(options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Add category to user's favorites list.
 * @summary Add Category To Favorites
 */
export const addCategoryToFavoritesApiCategoriesCategoryIdFavoritePost = (
	categoryId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<CategoryFavoriteResponse>(
		{ url: `/api/categories/${categoryId}/favorite`, method: 'POST', signal },
		options
	);
};

export const getAddCategoryToFavoritesApiCategoriesCategoryIdFavoritePostMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof addCategoryToFavoritesApiCategoriesCategoryIdFavoritePost>>,
		TError,
		{ categoryId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof addCategoryToFavoritesApiCategoriesCategoryIdFavoritePost>>,
	TError,
	{ categoryId: string },
	TContext
> => {
	const mutationKey = ['addCategoryToFavoritesApiCategoriesCategoryIdFavoritePost'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof addCategoryToFavoritesApiCategoriesCategoryIdFavoritePost>>,
		{ categoryId: string }
	> = (props) => {
		const { categoryId } = props ?? {};

		return addCategoryToFavoritesApiCategoriesCategoryIdFavoritePost(categoryId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type AddCategoryToFavoritesApiCategoriesCategoryIdFavoritePostMutationResult = NonNullable<
	Awaited<ReturnType<typeof addCategoryToFavoritesApiCategoriesCategoryIdFavoritePost>>
>;

export type AddCategoryToFavoritesApiCategoriesCategoryIdFavoritePostMutationError =
	HTTPValidationError;

/**
 * @summary Add Category To Favorites
 */
export const createAddCategoryToFavoritesApiCategoriesCategoryIdFavoritePost = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof addCategoryToFavoritesApiCategoriesCategoryIdFavoritePost>>,
			TError,
			{ categoryId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof addCategoryToFavoritesApiCategoriesCategoryIdFavoritePost>>,
	TError,
	{ categoryId: string },
	TContext
> => {
	const mutationOptions =
		getAddCategoryToFavoritesApiCategoriesCategoryIdFavoritePostMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Remove category from user's favorites list.
 * @summary Remove Category From Favorites
 */
export const removeCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDelete = (
	categoryId: string,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<CategoryFavoriteResponse>(
		{ url: `/api/categories/${categoryId}/favorite`, method: 'DELETE' },
		options
	);
};

export const getRemoveCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDeleteMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof removeCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDelete>>,
		TError,
		{ categoryId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof removeCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDelete>>,
	TError,
	{ categoryId: string },
	TContext
> => {
	const mutationKey = ['removeCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDelete'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof removeCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDelete>>,
		{ categoryId: string }
	> = (props) => {
		const { categoryId } = props ?? {};

		return removeCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDelete(
			categoryId,
			requestOptions
		);
	};

	return { mutationFn, ...mutationOptions };
};

export type RemoveCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDeleteMutationResult =
	NonNullable<
		Awaited<ReturnType<typeof removeCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDelete>>
	>;

export type RemoveCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDeleteMutationError =
	HTTPValidationError;

/**
 * @summary Remove Category From Favorites
 */
export const createRemoveCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDelete = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof removeCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDelete>>,
			TError,
			{ categoryId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof removeCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDelete>>,
	TError,
	{ categoryId: string },
	TContext
> => {
	const mutationOptions =
		getRemoveCategoryFromFavoritesApiCategoriesCategoryIdFavoriteDeleteMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Get all categories as a tree structure.
 * @summary Get Category Tree
 */
export const getCategoryTreeApiCategoriesTreeGet = (
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<CategoryTree[]>(
		{ url: `/api/categories/tree`, method: 'GET', signal },
		options
	);
};

export const getGetCategoryTreeApiCategoriesTreeGetQueryKey = () => {
	return [`/api/categories/tree`] as const;
};

export const getGetCategoryTreeApiCategoriesTreeGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getCategoryTreeApiCategoriesTreeGet>>,
	TError = unknown
>(options?: {
	query?: Partial<
		CreateQueryOptions<
			Awaited<ReturnType<typeof getCategoryTreeApiCategoriesTreeGet>>,
			TError,
			TData
		>
	>;
	request?: SecondParameter<typeof customInstance>;
}) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetCategoryTreeApiCategoriesTreeGetQueryKey();

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getCategoryTreeApiCategoriesTreeGet>>> = ({
		signal
	}) => getCategoryTreeApiCategoriesTreeGet(requestOptions, signal);

	return { queryKey, queryFn, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getCategoryTreeApiCategoriesTreeGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryTreeApiCategoriesTreeGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getCategoryTreeApiCategoriesTreeGet>>
>;
export type GetCategoryTreeApiCategoriesTreeGetQueryError = unknown;

/**
 * @summary Get Category Tree
 */

export function createGetCategoryTreeApiCategoriesTreeGet<
	TData = Awaited<ReturnType<typeof getCategoryTreeApiCategoriesTreeGet>>,
	TError = unknown
>(
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getCategoryTreeApiCategoriesTreeGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetCategoryTreeApiCategoriesTreeGetQueryOptions(options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Get a specific category by ID.
 * @summary Get Category
 */
export const getCategoryApiCategoriesCategoryIdGet = (
	categoryId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<CategoryRead>(
		{ url: `/api/categories/${categoryId}`, method: 'GET', signal },
		options
	);
};

export const getGetCategoryApiCategoriesCategoryIdGetQueryKey = (categoryId?: string) => {
	return [`/api/categories/${categoryId}`] as const;
};

export const getGetCategoryApiCategoriesCategoryIdGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getCategoryApiCategoriesCategoryIdGet>>,
	TError = HTTPValidationError
>(
	categoryId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getCategoryApiCategoriesCategoryIdGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getGetCategoryApiCategoriesCategoryIdGetQueryKey(categoryId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getCategoryApiCategoriesCategoryIdGet>>
	> = ({ signal }) => getCategoryApiCategoriesCategoryIdGet(categoryId, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!categoryId, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getCategoryApiCategoriesCategoryIdGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryApiCategoriesCategoryIdGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getCategoryApiCategoriesCategoryIdGet>>
>;
export type GetCategoryApiCategoriesCategoryIdGetQueryError = HTTPValidationError;

/**
 * @summary Get Category
 */

export function createGetCategoryApiCategoriesCategoryIdGet<
	TData = Awaited<ReturnType<typeof getCategoryApiCategoriesCategoryIdGet>>,
	TError = HTTPValidationError
>(
	categoryId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getCategoryApiCategoriesCategoryIdGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetCategoryApiCategoriesCategoryIdGetQueryOptions(categoryId, options);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}

/**
 * Update a category.
 * @summary Update Category
 */
export const updateCategoryApiCategoriesCategoryIdPut = (
	categoryId: string,
	categoryUpdate: CategoryUpdate,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<CategoryRead>(
		{
			url: `/api/categories/${categoryId}`,
			method: 'PUT',
			headers: { 'Content-Type': 'application/json' },
			data: categoryUpdate
		},
		options
	);
};

export const getUpdateCategoryApiCategoriesCategoryIdPutMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof updateCategoryApiCategoriesCategoryIdPut>>,
		TError,
		{ categoryId: string; data: CategoryUpdate },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof updateCategoryApiCategoriesCategoryIdPut>>,
	TError,
	{ categoryId: string; data: CategoryUpdate },
	TContext
> => {
	const mutationKey = ['updateCategoryApiCategoriesCategoryIdPut'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof updateCategoryApiCategoriesCategoryIdPut>>,
		{ categoryId: string; data: CategoryUpdate }
	> = (props) => {
		const { categoryId, data } = props ?? {};

		return updateCategoryApiCategoriesCategoryIdPut(categoryId, data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type UpdateCategoryApiCategoriesCategoryIdPutMutationResult = NonNullable<
	Awaited<ReturnType<typeof updateCategoryApiCategoriesCategoryIdPut>>
>;
export type UpdateCategoryApiCategoriesCategoryIdPutMutationBody = CategoryUpdate;
export type UpdateCategoryApiCategoriesCategoryIdPutMutationError = HTTPValidationError;

/**
 * @summary Update Category
 */
export const createUpdateCategoryApiCategoriesCategoryIdPut = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof updateCategoryApiCategoriesCategoryIdPut>>,
			TError,
			{ categoryId: string; data: CategoryUpdate },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof updateCategoryApiCategoriesCategoryIdPut>>,
	TError,
	{ categoryId: string; data: CategoryUpdate },
	TContext
> => {
	const mutationOptions = getUpdateCategoryApiCategoriesCategoryIdPutMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Delete a category. Subcategories will be moved to parent level. Trackers will become uncategorized.
 * @summary Delete Category
 */
export const deleteCategoryApiCategoriesCategoryIdDelete = (
	categoryId: string,
	options?: SecondParameter<typeof customInstance>
) => {
	return customInstance<void>({ url: `/api/categories/${categoryId}`, method: 'DELETE' }, options);
};

export const getDeleteCategoryApiCategoriesCategoryIdDeleteMutationOptions = <
	TError = HTTPValidationError,
	TContext = unknown
>(options?: {
	mutation?: CreateMutationOptions<
		Awaited<ReturnType<typeof deleteCategoryApiCategoriesCategoryIdDelete>>,
		TError,
		{ categoryId: string },
		TContext
	>;
	request?: SecondParameter<typeof customInstance>;
}): CreateMutationOptions<
	Awaited<ReturnType<typeof deleteCategoryApiCategoriesCategoryIdDelete>>,
	TError,
	{ categoryId: string },
	TContext
> => {
	const mutationKey = ['deleteCategoryApiCategoriesCategoryIdDelete'];
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof deleteCategoryApiCategoriesCategoryIdDelete>>,
		{ categoryId: string }
	> = (props) => {
		const { categoryId } = props ?? {};

		return deleteCategoryApiCategoriesCategoryIdDelete(categoryId, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type DeleteCategoryApiCategoriesCategoryIdDeleteMutationResult = NonNullable<
	Awaited<ReturnType<typeof deleteCategoryApiCategoriesCategoryIdDelete>>
>;

export type DeleteCategoryApiCategoriesCategoryIdDeleteMutationError = HTTPValidationError;

/**
 * @summary Delete Category
 */
export const createDeleteCategoryApiCategoriesCategoryIdDelete = <
	TError = HTTPValidationError,
	TContext = unknown
>(
	options?: {
		mutation?: CreateMutationOptions<
			Awaited<ReturnType<typeof deleteCategoryApiCategoriesCategoryIdDelete>>,
			TError,
			{ categoryId: string },
			TContext
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateMutationResult<
	Awaited<ReturnType<typeof deleteCategoryApiCategoriesCategoryIdDelete>>,
	TError,
	{ categoryId: string },
	TContext
> => {
	const mutationOptions = getDeleteCategoryApiCategoriesCategoryIdDeleteMutationOptions(options);

	return createMutation(() => ({ ...mutationOptions, queryClient }));
};
/**
 * Get a category with its full path from root.
 * @summary Get Category With Path
 */
export const getCategoryWithPathApiCategoriesCategoryIdPathGet = (
	categoryId: string,
	options?: SecondParameter<typeof customInstance>,
	signal?: AbortSignal
) => {
	return customInstance<CategoryWithPath>(
		{ url: `/api/categories/${categoryId}/path`, method: 'GET', signal },
		options
	);
};

export const getGetCategoryWithPathApiCategoriesCategoryIdPathGetQueryKey = (
	categoryId?: string
) => {
	return [`/api/categories/${categoryId}/path`] as const;
};

export const getGetCategoryWithPathApiCategoriesCategoryIdPathGetQueryOptions = <
	TData = Awaited<ReturnType<typeof getCategoryWithPathApiCategoriesCategoryIdPathGet>>,
	TError = HTTPValidationError
>(
	categoryId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getCategoryWithPathApiCategoriesCategoryIdPathGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	}
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getGetCategoryWithPathApiCategoriesCategoryIdPathGetQueryKey(categoryId);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof getCategoryWithPathApiCategoriesCategoryIdPathGet>>
	> = ({ signal }) =>
		getCategoryWithPathApiCategoriesCategoryIdPathGet(categoryId, requestOptions, signal);

	return { queryKey, queryFn, enabled: !!categoryId, ...queryOptions } as CreateQueryOptions<
		Awaited<ReturnType<typeof getCategoryWithPathApiCategoriesCategoryIdPathGet>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCategoryWithPathApiCategoriesCategoryIdPathGetQueryResult = NonNullable<
	Awaited<ReturnType<typeof getCategoryWithPathApiCategoriesCategoryIdPathGet>>
>;
export type GetCategoryWithPathApiCategoriesCategoryIdPathGetQueryError = HTTPValidationError;

/**
 * @summary Get Category With Path
 */

export function createGetCategoryWithPathApiCategoriesCategoryIdPathGet<
	TData = Awaited<ReturnType<typeof getCategoryWithPathApiCategoriesCategoryIdPathGet>>,
	TError = HTTPValidationError
>(
	categoryId: string,
	options?: {
		query?: Partial<
			CreateQueryOptions<
				Awaited<ReturnType<typeof getCategoryWithPathApiCategoriesCategoryIdPathGet>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customInstance>;
	},
	queryClient?: QueryClient
): CreateQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
	const queryOptions = getGetCategoryWithPathApiCategoriesCategoryIdPathGetQueryOptions(
		categoryId,
		options
	);

	const query = createQuery(() => ({ ...queryOptions, queryClient })) as CreateQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	query.queryKey = queryOptions.queryKey;

	return query;
}
